import ComposeViewState from '../store/schema/ComposeViewState';
import { mutatorAction } from 'satcheljs';

export default mutatorAction('removeAppendOnSend', (viewState: ComposeViewState) => {
    viewState.appendOnSend = [];
});
